/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Image, Form, DropdownButton } from 'react-bootstrap'

function ImportBtn({ setting }) {
  const { className = 'btn btn-primary btn-lg', currentID } = setting
  const [isUpload, setIsUpload] = useState(false)
  const [uploadFile, setUploadFile] = useState('')
  const getModuleText = (id) => {
    switch (id) {
      case 1:
        return 'PESTEL'
      case 2:
        return '競品分析'
      case 3:
        return '顧客旅程'
      case 4:
        return '人物誌'
      default:
        return 'PESTEL'
    }
  }

  const [currentModuleText] = useState(getModuleText(currentID))

  return (
    <DropdownButton
      align="start"
      title={
        <div className={className}>
          <div
            className="svgIcon"
            style={{
              maskImage: `url('/images/svgicons/import2.svg')`,
              marginRight: '10px',
            }}
          >
            import
          </div>
          匯入{currentModuleText}
        </div>
      }
    >
      <div className="toggle-wrap shadow-block import-wrap">
        <Form className="">
          <strong className="toggle-wrap-title">從電腦上傳檔案</strong>
          <p>
            請上傳.xlsx表格，系統會將表格內容轉換成可以編輯、可以重新生成的格式並覆蓋當前畫面。
          </p>
          <div className="drag-area">
            <Form.Label htmlFor="uploadfile" className="w-100">
              <div className={`notUpload ${isUpload && 'd-none'}`}>
                <Image
                  src="/images/drag-area-img.png"
                  className="img-fluid file-img"
                  alt=""
                />
                <p className="text-center">將檔案拖放至此或</p>
              </div>
              <div className={`isUpload ${!isUpload && 'd-none'}`}>
                <strong>{uploadFile}</strong>
              </div>
              <div className="btn btn-primary btn-md">
                <div
                  className="svgIcon"
                  style={{
                    maskImage: `url('/images/toolicons/upload.svg')`,
                    transform: 'translateY(1px)',
                  }}
                >
                  icon
                </div>
                {isUpload ? '重新上傳' : '選擇檔案'}
              </div>
            </Form.Label>
            <Form.Control
              id="uploadfile"
              name="uploadfile"
              type="file"
              onChange={(e) => {
                if (e.target.value !== '') {
                  setUploadFile(e.target.files[0].name)
                  setIsUpload(true)
                }
              }}
            />
            <p>
              尚未準備檔案？您可以點擊「匯出xlsx」進行修改，或下載
              <a href="" download className="text-decoration-underline">
                此範本
              </a>
              填寫後再上傳。
            </p>
          </div>
        </Form>
      </div>
    </DropdownButton>
  )
}

ImportBtn.propTypes = {
  setting: PropTypes.shape().isRequired,
}

export default ImportBtn
